import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicLayout from "../components/layout/PublicLayout";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { TrendingUp, ShieldCheck, Wallet, KeyRound } from "lucide-react";
import { toast } from "sonner";


export default function ListYourCar() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [upgrading, setUpgrading] = useState(false);

  const go = async () => {
    if (!user) {
      try { localStorage.setItem("rx_intent", "host"); } catch {}
      nav("/register", { state: { role: "owner", from: "/owner/cars/new" } });
      return;
    }
    if (user.role === "owner" || user.role === "admin") {
      try { localStorage.setItem(`rx_mode_${user.id}`, "hosting"); } catch {}
      nav("/owner/cars/new");
      return;
    }
    // customer — upgrade them to host on the spot
    setUpgrading(true);
    try {
      await api.post("/users/me/become-host");
      await refresh();
      try { localStorage.setItem(`rx_mode_${user.id}`, "hosting"); } catch {}
      toast.success("You're now a host! Let's list your first car.");
      nav("/owner/cars/new");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setUpgrading(false);
    }
  };
  return (
    <PublicLayout>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-2xl">
          <div className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold mb-3">For owners</div>
          <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter">Turn your car<br /> into income.</h1>
          <p className="mt-5 text-muted-foreground leading-relaxed max-w-lg">
            Whether it&apos;s your weekend SUV or a fleet of sedans, RydeXpress helps you reach travelers and locals across Rwanda. Set your price. Approve renters. Get paid in your currency.
          </p>
          <Button onClick={go} disabled={upgrading} className="mt-6 bg-accent text-accent-foreground hover:bg-accent/90 btn-lift" data-testid="list-your-car-cta">{upgrading ? "Setting up your host account…" : "List your car →"}</Button>
        </div>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { i: TrendingUp, t: "Earn on your terms", d: "Approve each booking. Block dates when your car isn't available." },
            { i: ShieldCheck, t: "Verified renters", d: "Every customer is identity-verified before they can book." },
            { i: Wallet, t: "Low 10% fee", d: "We only earn when you do. No subscription, no listing fees." },
            { i: KeyRound, t: "Hand off in person", d: "Meet renters at your pickup spot — keep full control of your keys." },
          ].map((b, i) => (
            <Card key={i} className="border-border p-6">
              <div className="w-9 h-9 rounded-md bg-primary text-primary-foreground flex items-center justify-center mb-3"><b.i size={16} /></div>
              <div className="font-display font-semibold">{b.t}</div>
              <div className="text-sm text-muted-foreground mt-1.5">{b.d}</div>
            </Card>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
